// extracted by mini-css-extract-plugin
export var searchHeader = "_5s-0";
export var searchHeaderDark = "_5s-1";